"use client";

import { Button } from "@/components/ui/button";
import ShareButton from "@/components/ui/share-button";
import { Spinner } from "@/components/ui/spinner";
import { useUser } from "@/lib/auth/session";
import type { EnrichedProfile } from "@/lib/supabase/types";
import { cn, getProfileLink } from "@/lib/utils";
import { EditIcon } from "lucide-react";
import Link from "next/link";

export default function ProfileOptions({
	profile,
	className,
}: { profile: EnrichedProfile; className?: string }) {
	const { user, isUserLoading, error } = useUser();
	if (isUserLoading) {
		return <Spinner className="size-5 self-center" />;
	}
	if (error) {
		console.error(error);
	}

	return (
		<div
			className={cn(
				"flex flex-row gap-4 items-center justify-between",
				className,
			)}
		>
			<div className="flex flex-row gap-4 items-center justify-between">
				<ShareButton
					type="profile"
					qrCode={true}
					profile={profile}
					title={profile?.name || ""}
					url={getProfileLink(profile?.username || profile?.id || "")}
				/>

				{profile?.id === user?.id && (
					<Button
						variant="ghost"
						size="default"
						className="border border-primary/20"
					>
						<Link href="/account/settings" className="flex items-center gap-1">
							<EditIcon size={20} />
							<span className="hidden sm:inline">Edit Profile</span>
						</Link>
					</Button>
				)}
			</div>
		</div>
	);
}
